import IFileData from "./IFileData";

export default class FileData implements IFileData
{
    public readonly filename?: string;
    public readonly url?: string;
    public readonly content?: string;

    constructor(props: IFileData)
    {
        this.filename = props.filename;
        this.url = props.url;
        this.content = props.content;
    }
}
